import { render, staticRenderFns } from "./itemPrompt.vue?vue&type=template&id=46525888&scoped=true&"
import script from "./itemPrompt.vue?vue&type=script&lang=ts&"
export * from "./itemPrompt.vue?vue&type=script&lang=ts&"
import style0 from "./itemPrompt.vue?vue&type=style&index=0&id=46525888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46525888",
  null
  
)

component.options.__file = "itemPrompt.vue"
export default component.exports